import React from "react";
import "./TestimonialsSection.css";

const testimonials = [
  {
    name: "Karan Patel",
    role: "Small Business Owner",
    text: "DoHostingPay helped me search and secure my brand domain quickly. The interface feels clean and simple.",
  },
  {
    name: "Neha Shah",
    role: "Digital Creator",
    text: "I liked the smooth flow from domain search to pricing. Everything looks modern and easy to understand.",
  },
  {
    name: "Vikram Rao",
    role: "Web Agency Lead",
    text: "The platform feels perfect for clients who need domains, hosting, email, and security in one place.",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        <div className="testimonial-heading">
          <span>Customer stories</span>
          <h2>Trusted by growing online brands</h2>
          <p>
            Businesses, creators, and agencies use DoHostingPay to launch their
            digital presence faster.
          </p>
        </div>

        <div className="testimonial-grid">
          {testimonials.map((item) => (
            <article className="testimonial-card" key={item.name}>
              <div className="quote-mark" aria-hidden="true">
                ”
              </div>

              <p className="testimonial-text">“{item.text}”</p>

              <div className="testimonial-user">
                <div className="user-avatar" aria-hidden="true">
                  {item.name.charAt(0)}
                </div>

                <div>
                  <h4>{item.name}</h4>
                  <span>{item.role}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;